<template>
  <DeepForwardSlots :slots="$slots">
    <DeepSupportDialog
      v-model="model"
      app-id="dashboard"
      :email="user?.email"
      :submit-fn="onSupportSubmit"
      @error="onSupportError"
    />
  </DeepForwardSlots>
</template>

<script setup lang="ts">
import { toast } from 'vue-sonner'
import { isAxiosError } from 'axios'
import {
  ContactSupportError,
  DeepForwardSlots,
  DeepSupportDialog,
} from '@deepcloud/deep-ui-lib'
import { useApi } from '@/composables/api'
import { useKeycloak } from '@/composables/auth/keycloak'
import type { ContactSupportForm } from '@deepcloud/deep-ui-lib'

const model = defineModel({
  type: Boolean,
  default: false,
})

const { user } = useKeycloak()
const { t } = useI18n()
const { deepAdminAPI } = useApi()

function onSupportSubmit(data: ContactSupportForm) {
  return deepAdminAPI.value.usersSupport.create({
    type: 'support',
    contact: user.value?.email || '',
    ...data,
  })
}

function onSupportError(error: ContactSupportError) {
  if (error.type === 'validation') {
    toast.error(t('error.validation.invalid'))
  } else {
    if (isAxiosError(error)) {
      toast.error(error.message)
    } else {
      toast.error(t('error.error_occurred'))
    }
  }
}
</script>
